/**
 *
 * @module tokenClientExtrasMap
 *
 */

/**
 *
 * @class TokenClientExtrasMap
 *
 */
export default class TokenClientExtrasMap {

    /**
     *
     * @param {String} platformId
     *
     */
    constructor(platformId) {

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the platform ID.
         *
         */
        this.platformId = platformId;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/tokenClientExtrasMap.js